/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participationreason1Inputs */

const en__field_participationreason1 = /** @type {(inputs: _Field_Participationreason1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do you want to partake in the mentoring Program`)
};

const de__field_participationreason1 = /** @type {(inputs: _Field_Participationreason1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum möchtest du am Career Mentoring-Programm teilnehmen?`)
};

/**
* | output |
* | --- |
* | "Why do you want to partake in the mentoring Program" |
*
* @param {_Field_Participationreason1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_participationreason1 = /** @type {((inputs?: _Field_Participationreason1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participationreason1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_participationreason1(inputs)
	return de__field_participationreason1(inputs)
});
export { _field_participationreason1 as "_field_participationReason" }